// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"DuplicateProductConfirmationPopup_confirmButton__1j_K2","declineButton":"DuplicateProductConfirmationPopup_declineButton__1pdAX"};